export default function UserDetail({ user }: any) {
	return <div>{user.email}</div>;
}
